module.exports = __webpack_public_path__ + "static/media/VestasSans-Extrabold.b42bb7c8.svg";